import React from 'react';
import RESectionHeader from './RESectionHeader';

export default function RERevenue() {
  return (
    <>
      <RESectionHeader title="Revenue" showHelp />
      <div className="mt-3 p-3">
        <h4>Revenue</h4>
        <p className="text-muted">Coming soon.</p>
      </div>
    </>
  );
}
